import { render, staticRenderFns } from "./ViewProducts.vue?vue&type=template&id=b6c83e50&"
import script from "./ViewProducts.vue?vue&type=script&lang=js&"
export * from "./ViewProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports